const NAVBARS_WITH_DROPDOWNS_ONLY_SLUGS = new Set([
  'navbar1_component',
  'navbar2_component',
  'navbar3_component',
  'navbar5_component',
  'navbar6_component',
  'navbar7_component',
  'navbar8_component',
  'navbar9_component',
  'navbar10_component',
  'navbar11_component',
  'navbar12_component',
  'navbar13_component',
  'navbar14_component',
  // navbar15_component has dropdowns, but they open to the top and don't work
  // properly in the site builder yet with the new select-to-open behaviour.
]);

const NAVBARS_WITH_DROPDOWNS_AND_HAMBURGER_MENU_SLUGS = new Set([
  'navbar19_component',
  'navbar20_component',
  'navbar21_component',
  'navbar22_component',
]);

/**
 * Returns whether the given component slug is a navbar with dropdowns that can
 * be opened when selected in the site builder.
 */
export const isNavbarWithDropdowns = (slug: string) =>
  NAVBARS_WITH_DROPDOWNS_ONLY_SLUGS.has(slug) ||
  NAVBARS_WITH_DROPDOWNS_AND_HAMBURGER_MENU_SLUGS.has(slug);

/**
 * Returns whether the given component slug is a navbar that only has dropdowns,
 * and no other type of menu (e.g. hamburger menu). This is used to disable the
 * "show/hide" toggle for the section.
 */
export const isNavbarWithDropdownsOnly = (slug: string) =>
  NAVBARS_WITH_DROPDOWNS_ONLY_SLUGS.has(slug);
